import React from 'react'
import { FiInbox } from "react-icons/fi";

function EmptyState() {
	return (
		<div className='container-md text-center p-10'>
			<FiInbox className='w-20 h-20 m-auto mb-4 text-gray-500' />
			<h2 className='text-xl font-bold mb-3'>No flights found !</h2>
			<p>We couldn't find any flights matching your search.</p>
			<p>Please refine your search or try again later.</p>
		</div>
	)
}

export default EmptyState